<template>
    <v-chip
        v-if="name"
        color="grey lighten-4"
        small
        style="font-size: 10px"
    >
        <v-row
            class="fill-height"
            no-gutters
            justify="center"
            align="center"
        >
            <span class="grey--text text--darken-1 font-weight-medium">
                {{ name }}
            </span>
        </v-row>
    </v-chip>
</template>

<script>
export default {
    name: "RichDataTableTopic",
    props: {
        name: {
            type: String,
            default: null
        }
    }
};
</script>
